export const environment = {
  production: false,
  staging: true,
  version: 1774194127244,
  dataPoolApiBaseUrl:
    'http://31third-datapool-api-stage-env.eba-ktmcfnbj.eu-central-1.elasticbeanstalk.com/0.1',
  tradingApiBaseUrl: 'https://api-stage.31third.com/1.3',
  tradingAPIKey: '69ce251d-2675-4e17-92c6-e4f29da3e8f5',
  sendLogs: true,
  sentryUrl:
    'https://3096343485734d1fa52a2126fff7873b@o4505465465339904.ingest.sentry.io/4505469937975296',
  walletConnectProjectId: '563e1e6eadbfbabd1280473e5de31ef8',
  tenderlyAccount: 'phips0812',
  tenderlyProject: '31third',
  tenderlyAccessKey: 'lbuTn992qH1lQGkSy5ZjGMnC1QiX67Fp',
};
